import { GraduationCap, Briefcase } from 'lucide-react'

import { EXPERIENCE } from '../data/site'
import { Reveal } from './Reveal'
import { Section } from './Section'
import styles from './Experience.module.css'

export function Experience() {
  return (
    <Section
      id="experience"
      eyebrow="Experience"
      title="Fifteen years of shipping, most of them leading."
      lead="From writing the code to setting the direction and growing the people who write it."
    >
      <ol className={styles.timeline}>
        {EXPERIENCE.map((role, i) => (
          <li
            key={`${role.org}-${role.title}`}
            className={styles.item}
            data-current={role.current || undefined}
          >
            {/*
              The marker sits outside <Reveal> on purpose: Reveal animates a
              transform, which would otherwise become the containing block for
              this absolutely positioned dot and knock it off the rail.
            */}
            <span className={styles.marker} aria-hidden="true">
              {role.kind === 'education' ? <GraduationCap size={15} /> : <Briefcase size={15} />}
            </span>

            <Reveal delay={Math.min(i * 60, 240)}>
              <article className={styles.card}>
                <p className={styles.period}>
                  <time dateTime={role.start}>{role.period}</time>
                  {role.current && <span className={styles.badge}>Current</span>}
                </p>

                <h3 className={styles.role}>{role.title}</h3>
                <p className={styles.org}>{role.org}</p>

                {role.summary && <p className={styles.summary}>{role.summary}</p>}

                {role.highlights && (
                  <ul className={styles.highlights}>
                    {role.highlights.map((highlight) => (
                      <li key={highlight}>{highlight}</li>
                    ))}
                  </ul>
                )}
              </article>
            </Reveal>
          </li>
        ))}
      </ol>
    </Section>
  )
}
